export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    answer: {
      type: Object,
      required: true
    }
  },

  computed: {
    totalScore () {
      if (!this.answer.result) return 0

      return this.answer.result
        .reduce((total, ans) => total + ans.score, 0)
    }
  }
}
